export enum TeamMemberStatus {
  Active = 'active',
  Deactivated = 'deactivated',
}
